import { render, staticRenderFns } from "./upload_config.vue?vue&type=template&id=7920b70b&scoped=true"
import script from "./upload_config.vue?vue&type=script&lang=js"
export * from "./upload_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7920b70b",
  null
  
)

export default component.exports